import { Tooltip, type TooltipProps } from '@mantine/core';

// direct child must have a ref! https://mantine.dev/core/tooltip/#required-ref-prop
// TODO - replace where applicable
export const MyTooltip = ({ children, ...props }: TooltipProps) => {
    return (
        <Tooltip position={'top-start'} withArrow arrowOffset={10} arrowSize={6} {...props}>
            <div style={{ width: '100%' }}>{children}</div>
        </Tooltip>
    );
};
